import React, { useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { seedFirestore } from '../../utils/seedFirestore';
import AdminEventos from './AdminEventos';
import AdminCultura from './AdminCultura';
import AdminRecomendaciones from './AdminRecomendaciones';

const TABS = [
  { key: 'eventos', label: 'Eventos' },
  { key: 'cultura', label: 'Cultura en la Casa' },
  { key: 'recomendaciones', label: 'Recomendaciones' },
];

const AdminPanel = () => {
  const [tab, setTab] = useState('eventos');
  const [seeding, setSeeding] = useState(false);
  const [seedProgress, setSeedProgress] = useState(0);
  const [seedDone, setSeedDone] = useState(false);

  const handleSeed = async () => {
    if (!window.confirm('Esto importará todos los datos actuales de los archivos locales a Firebase. ¿Continuar?')) return;
    setSeeding(true);
    setSeedDone(false);
    try {
      await seedFirestore(setSeedProgress);
      setSeedDone(true);
    } finally {
      setSeeding(false);
    }
  };

  return (
    <div className="admin-panel">
      <aside className="admin-sidebar">
        <div className="admin-logo">ConTarte<br /><span>Panel de administración</span></div>
        <nav>
          {TABS.map(t => (
            <button
              key={t.key}
              className={`admin-nav-btn${tab === t.key ? ' active' : ''}`}
              onClick={() => setTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <button className="admin-btn" onClick={() => signOut(auth)}>Cerrar sesión</button>
          <div className="admin-seed">
            <button
              className="admin-btn admin-btn-seed"
              onClick={handleSeed}
              disabled={seeding}
              title="Importar datos de los archivos JS a Firebase (solo primera vez)"
            >
              {seeding ? `Importando... ${seedProgress}%` : 'Importar datos iniciales'}
            </button>
            {seedDone && <p className="admin-seed-ok">¡Importación completa!</p>}
          </div>
        </div>
      </aside>

      <main className="admin-content">
        {tab === 'eventos' && <AdminEventos />}
        {tab === 'cultura' && <AdminCultura />}
        {tab === 'recomendaciones' && <AdminRecomendaciones />}
      </main>
    </div>
  );
};

export default AdminPanel;
